<td class="hover-more-info">
  <div class="d-flex align-items-center">
    <!-- <div class="symbol symbol-50px w-50px h-50px d-flex flex-center border me-3">
      <i class="fs-2x ki-duotone ki-wallet"
        ><i class="path1"></i
        ><i class="path2"></i
        ><i class="path3"></i
        ><i class="path4"></i
        ><i class="path5"></i
      ></i>
    </div> -->

    <div class="d-flex justify-content-start flex-column">
      <div class="d-flex align-items-center">
        <div
        *ngIf="!!transaction?.category"
          ngxTippy="<strong>{{ transaction.category.name }}</strong>"
          class="symbol symbol-50px me-4"
        >
          <span class="symbol-label border"
            ><img
              *ngIf="!!transaction.category.logo"
              class="w-75 align-self-center"
              src="{{ transaction.category.logo }}"
            />

            <span *ngIf="!transaction.category.logo">{{ "Icon" }}</span>
          </span>
        </div>

        <div class="d-flex flex-column">
          <div class="d-flex align-items-center mb-1 gap-1">
            <!-- <a
              class="text-gray-800 fw-bold text-hover-primary fs-6"
              ngxTippy="{{ transaction.amount.value }} <strong>{{
                transaction?.wallet?.balance?.currency?.code
              }}</strong> ({{ transaction?.wallet?.balance?.currency?.name }})"
              >{{ transaction.amount | moneyFormat }}</a
            > -->



          </div>
          <div class="d-flex text-gray-400 fw-semibold d-block fs-7">

            <app-wallet-item-popover [walletItem]="transaction.wallet">
              <!-- <span class="badge badge-light d-flex align-items-center gap-1 me-4">
                <i class="fs-2 ki-duotone ki-wallet"
                  ><i class="path1"></i><i class="path2"></i
                  ><i class="path3"></i><i class="path4"></i
                  ><i class="path5"></i></i
                >{{ transaction.wallet.name }}
              </span> -->
            </app-wallet-item-popover>

            <span *ngIf="!!transaction?.category" ngxTippy="For <strong>{{transaction.category.name}}</strong>" class="badge badge-light-primary">{{ transaction.category.name }}</span>
            <!-- <span *ngIf="transaction.type == TransactionTypeEnum.debt && !transaction?.category" ngxTippy="From <strong>{{transaction.contact?.firstName}} {{transaction.contact?.lastName}}</strong>" class="badge badge-light-success">Debt</span>
            <span *ngIf="transaction.type == TransactionTypeEnum.credit && !transaction?.category" ngxTippy="For <strong>{{transaction.contact?.firstName}} {{transaction.contact?.lastName}}</strong>" class="badge badge-light-danger">Credit</span> -->

          </div>
        </div>
      </div>
    </div>
  </div>
</td>

<td class="ps-12 text-muted pe-12">
  {{ transaction.description }}
</td>

<td class="text-end">
  <a
    href="#"
    class="btn btn-sm btn-icon btn-bg-light btn-active-color-primary w-30px h-30px"
  >
    <i class="ki-outline ki-black-right fs-2 text-gray-500"></i>
  </a>
</td>
